import {
    FETCH_LEDMODULES,
    GET_SELECTED_LEDMODULES,
    UPDATE_SELECTED_LEDMODULES,
    FETCH_PROPERTIES_LEDMODULES,
    UPDATE_PROPERTIES_LEDMODULES
} from '../actions/types';

const INITIAL_STATE = {
    ledmodules: null,
    ledmodule: null,
    validationSummary: null,
    ledmodulesProperties: null
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case FETCH_LEDMODULES:

            const arr = [];
            for (var i=0;i<action.payload.length; i++) {
                if (action.payload[i].id !== 1) {
                    arr.push(action.payload[i]);
                }
            }
            return Object.assign({}, state, {
                ledmodules: arr,
            });
        case GET_SELECTED_LEDMODULES:
            return Object.assign({}, state, {
                ledmodule: action.payload,
            });
        case UPDATE_SELECTED_LEDMODULES:
            return Object.assign({}, state, {
                validationSummary: action.payload,
            });
        case FETCH_PROPERTIES_LEDMODULES:
            return Object.assign({}, state, {
                ledmodulesProperties: action.payload,
            });
        case UPDATE_PROPERTIES_LEDMODULES:
            return Object.assign({}, state, {
                validationSummary: action.payload,
            });
        default:
            return state;
    }
};
